// For private, pure derived values only. Entries are FIFO-bounded; oversized
// provider strings are computed without retention. Never use this for promises,
// mutable caller-owned results, authorization, or live quote data.
export function boundedMemo(compute, capacity, maxKeyLength = 8192) {
  const cache = new Map()
  return key => {
    if (typeof key === 'string' && key.length > maxKeyLength) return compute(key)
    if (cache.has(key)) return cache.get(key)
    const value = compute(key)
    if (cache.size >= capacity) cache.delete(cache.keys().next().value)
    cache.set(key, value)
    return value
  }
}
